import { takeEvery, put } from "redux-saga/effects";
import { request } from '../../api/Service';
import { getErrorMessage } from '../../components/utils/errorHandler';
import { toast } from 'react-toastify';
import {store} from "../store";


export default function* watcherCompanySaga() {
    yield takeEvery("ADD_COMPANY", workerSaga);
}

function* workerSaga(action) {
    try {

        yield put({ type: "LOADING_BUTTON_SPINNER" });
        // let payload = {}
        yield request("post", action.payload, "api/Company/add-company").then(response => {
            //payload = response;
        });
        var payload = {
            email: "",
            password: "",
            userId: store.getState().persistReducer.userId
        }
        alert("Company Added Successfully")
        yield put({ type: "AUTO_LOGIN", payload: payload });

    } catch (e) {
        console.log("add-company-saga", e)
        console.log("add-company-saga", e.response)
        yield put({ type: "LOADING_BUTTON_SPINNER" });
        const errorMessage = getErrorMessage(e.response);
        toast.error(errorMessage);
        yield put({ type: "API_ERRORED", payload: e });
    }
}
